var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCarLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7948 21.2707H12.2148C11.1103 21.2707 10.2148 22.1661 10.2148 23.2707V28.0507C10.2148 29.1553 11.1103 30.0507 12.2148 30.0507H35.7948C36.8994 30.0507 37.7948 29.1553 37.7948 28.0507V23.2707C37.7948 22.1661 36.8994 21.2707 35.7948 21.2707Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1349 21.2207H11.8749L14.0649 13.8307C14.4349 12.5807 15.5849 11.7207 16.8849 11.7207H31.1049C32.4049 11.7207 33.5549 12.5807 33.9249 13.8307L36.1149 21.2207H36.1349Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2148 27.9004V34.7704",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7949 27.9004V34.7704",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7849 27.1304C15.5968 27.1304 16.2549 26.4723 16.2549 25.6604C16.2549 24.8486 15.5968 24.1904 14.7849 24.1904C13.9731 24.1904 13.3149 24.8486 13.3149 25.6604C13.3149 26.4723 13.9731 27.1304 14.7849 27.1304Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2249 27.1304C34.0367 27.1304 34.6949 26.4723 34.6949 25.6604C34.6949 24.8486 34.0367 24.1904 33.2249 24.1904C32.413 24.1904 31.7549 24.8486 31.7549 25.6604C31.7549 26.4723 32.413 27.1304 33.2249 27.1304Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarLight);
export default __webpack_public_path__ + "static/media/icon_car_light.228b2055.svg";
export { ForwardRef as ReactComponent };